import React  from 'react'
import { Breadcrumb, Button, Flex, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { ArrowRightOutlined, BulbOutlined, HomeOutlined } from '@ant-design/icons'
function SketchDesc(props) {
    const navigate = useNavigate()
    // 从父组件获取单个数据项和面包屑参数
    const item = props.data || null
    const { bxm_id, yh_name, bxmxq_name, bxmbb_name, bxm_name, yh_id } = props
    return (
        <div style={{marginTop:'30px', position: 'relative'}}>
            <Flex justify='space-between' align='start'>
                <Breadcrumb
                    items={[
                        {
                            title: <a onClick={() => {navigate(`/SketchProject?bxm_id=${bxm_id}`)}}><HomeOutlined /> 首页</a>
                        },
                        {
                            title: yh_name
                        },
                        {
                            title: bxmxq_name
                        },
                        {
                            title: bxmbb_name
                        },
                    ]}
                />          
                <Button type="primary" onClick={() => {navigate(`/SketchProject?bxm_id=${bxm_id}`)}}>返回上一级</Button>
            </Flex>
            
            {/* 图片预览弹框 */}


            {item ? (
                <>
                    <div style={{ textAlign: 'center',marginTop:'20px'}}>
                        <img 
                            src={`/api/assets/images/application/${item.bxmbb_image || item.bxmbb_name}`} 
                            alt={item.bxmbb_name || ''} 
                            style={{
                                width: '100%',
                                maxWidth: '1440px',
                                height: 'auto',
                                objectFit: 'cover',
                                display: 'block',
                                margin: '0 auto',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                border: '2px #000 solid',
                            }}
                            onError={(e) => {
                                e.target.src = '/img/home/logo.png';
                            }}                       
                        />
                        
                    </div>
                    <Space style={{marginTop:'15px',marginLeft:'50px',fontSize:'18px',lineHeight:'1.6',color:'#000'}}>
                        <BulbOutlined /><div dangerouslySetInnerHTML={{__html: item.bxmbb_content}}></div>
                    </Space>
                    <div style={{marginTop:'15px',textAlign:'right',marginRight:'15px'}}>
                        <a onClick={() => {navigate(`/SketchLogs?bxmbb_id=${item.bxmbb_id}&bxm_id=${bxm_id}&bxmxq_name=${bxmxq_name}&bxmbb_name=${bxmbb_name}&yh_name=${yh_name}&bxm_name=${bxm_name}&yh_id=${yh_id}`)}}>修改日志 <ArrowRightOutlined /></a>
                    </div>
                </>
            ) : (
                <div style={{
                    textAlign: 'center',
                    padding: '50px 20px',
                    color: '#999',
                    fontSize: '16px'
                }}>
                    <div style={{fontSize: '48px', marginBottom: '20px'}}>📷</div>
                    <div>暂无图片内容</div>
                </div>
            )}
        </div>
    )
}

export default SketchDesc